import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use", "children", "borderRadius", "borderStartStartRadius", "borderStartEndRadius", "borderEndEndRadius", "borderEndStartRadius"];
import { getBackgroundColorToken, getBadgeStyleOverrides } from './Badge.helpers';
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useBadgeContext } from './BadgeProvider';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledBadge = styled.span.withConfig({
  displayName: "Badge__StyledBadge",
  componentId: "sc-165fv87-0"
})(({
  $cssStyles,
  $styleOverrides,
  $use,
  theme
}) => {
  const dotSize = '12px'; // TODO https://git.hubteam.com/HubSpot/foundations-components/issues/5943
  const badgeMinSize = '23px'; // TODO https://git.hubteam.com/HubSpot/foundations-components/issues/5943
  const {
    fontFamily,
    fontWeight
  } = theme.typography['heading-25'];
  return Object.assign({}, $cssStyles, {
    textAlign: 'center'
  }, $use === 'count' || $use === 'dot' ? Object.assign({
    display: 'inline-block',
    backgroundColor: theme.color['fill-transitional-alert'],
    border: `${theme.borderWidth['200']} solid ${theme.color['border-core-on-fill-default']}`,
    borderStartStartRadius: theme.borderRadius['full'],
    borderStartEndRadius: theme.borderRadius['full'],
    borderEndEndRadius: theme.borderRadius['full'],
    borderEndStartRadius: theme.borderRadius['full'],
    pointerEvents: 'none',
    verticalAlign: 'baseline'
  }, $use === 'count' && {
    fontFamily,
    fontWeight,
    color: theme.color['text-core-on-fill-default'],
    paddingBlock: `${theme.space['0']}`,
    paddingInline: `${theme.space['100']}`,
    // no tokens for the below properties
    fontSize: '11px',
    lineHeight: '19px',
    // not available on Figma but necessary to match the design
    minBlockSize: badgeMinSize,
    minInlineSize: badgeMinSize
  }, $use === 'dot' && {
    blockSize: dotSize,
    inlineSize: dotSize,
    textIndent: '-1000rem'
  }) : {
    fontFamily,
    fontWeight,
    display: 'inline-flex',
    textTransform: 'uppercase',
    verticalAlign: 'inherit',
    hyphens: 'manual',
    borderStartStartRadius: theme.borderRadius['transitional-full-3'],
    borderStartEndRadius: theme.borderRadius['transitional-full-3'],
    borderEndEndRadius: theme.borderRadius['transitional-full-3'],
    borderEndStartRadius: theme.borderRadius['transitional-full-3'],
    minHeight: '20px',
    // TODO https://git.hubteam.com/HubSpot/foundations-components/issues/5943
    backgroundColor: theme.color[getBackgroundColorToken($use)],
    color: theme.color[$use === 'koala' ? 'text-core-default' : 'text-core-on-fill-default'],
    paddingBlock: `${theme.space['0']}`,
    paddingInline: `${theme.space['200']}`,
    lineHeight: '20px',
    // TODO https://git.hubteam.com/HubSpot/foundations-components/issues/5943
    // no tokens for the below properties
    fontSize: '10px' // TODO https://git.hubteam.com/HubSpot/foundations-components/issues/5943
  }, $styleOverrides);
});
export const Badge = _ref => {
  let {
      use = 'free',
      children,
      borderRadius,
      borderStartStartRadius,
      borderStartEndRadius,
      borderEndEndRadius,
      borderEndStartRadius
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const theme = useTheme();
  const badgeContext = useBadgeContext();
  const badgeStyleOverrides = getBadgeStyleOverrides({
    use,
    theme,
    borderRadius,
    borderStartStartRadius,
    borderStartEndRadius,
    borderEndStartRadius,
    borderEndEndRadius,
    badgeContext
  });
  return /*#__PURE__*/_jsx(StyledBadge, Object.assign({
    $cssStyles: cssStyles,
    $styleOverrides: badgeStyleOverrides,
    $use: use
  }, domProps, {
    children: /*#__PURE__*/_jsx("span", {
      children: children
    })
  }));
};